// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleMenuRouteRouteImport } from './routes/$locale/menu/route'
import { Route as LocaleOrderRouteRouteImport } from './routes/$locale/order/route'
import { Route as ErrorIndexRouteImport } from './routes/error/index'
import { Route as OriginIndexRouteImport } from './routes/origin/index'
import { Route as LocaleCheckoutIndexRouteImport } from './routes/$locale/checkout/index'
import { Route as LocaleKioskOrderIdRouteImport } from './routes/$locale/kiosk/$orderId'
import { Route as LocaleMenuIndexRouteImport } from './routes/$locale/menu/index'
import { Route as LocaleOrderIndexRouteImport } from './routes/$locale/order/index'
import { Route as LocaleOrderOrderReferenceRouteImport } from './routes/$locale/order/$orderReference'
import { Route as LocaleProductsSlugRouteImport } from './routes/$locale/products/$slug'
import { Route as LocaleQrIndexRouteImport } from './routes/$locale/qr/index'
import { Route as LocaleQrCartRouteImport } from './routes/$locale/qr/cart'
import { Route as QrTTokenRouteImport } from './routes/qr/t/$token'
import { Route as LocaleQrRoundQrRoundIdRouteImport } from './routes/$locale/qr/round/$qrRoundId'
import { Route as LocaleQrTTokenRouteImport } from './routes/$locale/qr/t/$token'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          })
const LocaleMenuRouteRoute = LocaleMenuRouteRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => LocaleRoute
          })
const LocaleOrderRouteRoute = LocaleOrderRouteRouteImport.update({
            id: '/order',path: '/order',getParentRoute: () => LocaleRoute
          })
const ErrorIndexRoute = ErrorIndexRouteImport.update({
            id: '/error/',path: '/error/',getParentRoute: () => rootRouteImport
          })
const OriginIndexRoute = OriginIndexRouteImport.update({
            id: '/origin/',path: '/origin/',getParentRoute: () => rootRouteImport
          })
const LocaleCheckoutIndexRoute = LocaleCheckoutIndexRouteImport.update({
            id: '/checkout/',path: '/checkout/',getParentRoute: () => LocaleRoute
          })
const LocaleKioskOrderIdRoute = LocaleKioskOrderIdRouteImport.update({
            id: '/kiosk/$orderId',path: '/kiosk/$orderId',getParentRoute: () => LocaleRoute
          })
const LocaleMenuIndexRoute = LocaleMenuIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleMenuRouteRoute
          })
const LocaleOrderIndexRoute = LocaleOrderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleOrderRouteRoute
          })
const LocaleOrderOrderReferenceRoute = LocaleOrderOrderReferenceRouteImport.update({
            id: '/$orderReference',path: '/$orderReference',getParentRoute: () => LocaleOrderRouteRoute
          })
const LocaleProductsSlugRoute = LocaleProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => LocaleRoute
          })
const LocaleQrIndexRoute = LocaleQrIndexRouteImport.update({
            id: '/qr/',path: '/qr/',getParentRoute: () => LocaleRoute
          })
const LocaleQrCartRoute = LocaleQrCartRouteImport.update({
            id: '/qr/cart',path: '/qr/cart',getParentRoute: () => LocaleRoute
          })
const QrTTokenRoute = QrTTokenRouteImport.update({
            id: '/qr/t/$token',path: '/qr/t/$token',getParentRoute: () => rootRouteImport
          })
const LocaleQrRoundQrRoundIdRoute = LocaleQrRoundQrRoundIdRouteImport.update({
            id: '/qr/round/$qrRoundId',path: '/qr/round/$qrRoundId',getParentRoute: () => LocaleRoute
          })
const LocaleQrTTokenRoute = LocaleQrTTokenRouteImport.update({
            id: '/qr/t/$token',path: '/qr/t/$token',getParentRoute: () => LocaleRoute
          })





const LocaleMenuRouteRouteChildren = {
  LocaleMenuIndexRoute: LocaleMenuIndexRoute
}

const LocaleMenuRouteRouteWithChildren = LocaleMenuRouteRoute._addFileChildren(LocaleMenuRouteRouteChildren)




const LocaleOrderRouteRouteChildren = {
  LocaleOrderOrderReferenceRoute: LocaleOrderOrderReferenceRoute,LocaleOrderIndexRoute: LocaleOrderIndexRoute
}

const LocaleOrderRouteRouteWithChildren = LocaleOrderRouteRoute._addFileChildren(LocaleOrderRouteRouteChildren)



const LocaleRouteChildren = {
  LocaleMenuRouteRoute: LocaleMenuRouteRouteWithChildren,LocaleOrderRouteRoute: LocaleOrderRouteRouteWithChildren,LocaleIndexRoute: LocaleIndexRoute,LocaleKioskOrderIdRoute: LocaleKioskOrderIdRoute,LocaleProductsSlugRoute: LocaleProductsSlugRoute,LocaleQrCartRoute: LocaleQrCartRoute,LocaleCheckoutIndexRoute: LocaleCheckoutIndexRoute,LocaleQrIndexRoute: LocaleQrIndexRoute,LocaleQrRoundQrRoundIdRoute: LocaleQrRoundQrRoundIdRoute,LocaleQrTTokenRoute: LocaleQrTTokenRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRoute: LocaleRouteWithChildren,ErrorIndexRoute: ErrorIndexRoute,OriginIndexRoute: OriginIndexRoute,QrTTokenRoute: QrTTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)